module.exports = __webpack_public_path__ + "static/media/Corn4V9-V12.5b1cce6e.png";